/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarShopDto } from './calendarShopDto';


export interface CalendarDayDto { 
    date?: string;
    isOpen?: boolean;
    orderCount?: number;
    shops?: Array<CalendarShopDto> | null;
}

